<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { Snippet } from "svelte";
	import Icon from "./common/Icon.svelte";

	const { icon, label }: { icon?: Snippet | string; label: string } = $props();
</script>

<div
	class="flex gap-2 lg:gap-6 flex-col items-center bg-nov-light-100 px-4 py-3 lg:pt-6 lg:pb-8 lg:px-5 border rounded-2xl lg:rounded-3xl"
>
	<div class="rounded-full size-16 xs:size-18 bg-white max-auto flex items-center justify-center">
		{#if typeof icon === "string"}
			<Icon {icon} class="w-10 h-10" />
		{:else if icon}
			{@render icon()}
		{/if}
	</div>
	<h3 class="text-md/6 tracking-[0.005em] text-center font-semibold">
		<Formatted text={label} />
	</h3>
</div>
